"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Lists.scss");
var Lists = function (_a) {
    var data = _a.data, testId = _a.testId;
    var ListType = data.type === "unordered" ||
        data.type === "unordered-svg" ||
        data.type === "unordered-svg-lg" ||
        data.type === "unordered-svg-sm"
        ? "ul"
        : "ol";
    /* Created variable to check the icon class and font class given as iput follow rules */
    var bulletClass = data.type === "unordered"
        ? "" + styles.bullet
        : data.type === "unordered-svg"
            ? "" + styles.bulletSvg
            : data.type === "unordered-svg-sm" &&
                data.fontClassName !== "type-xs" &&
                data.fontClassName !== "type-xxs"
                ? "" + styles.bulletSvgSm
                : data.type === "unordered-svg-lg" && data.fontClassName === "type-sm"
                    ? "" + styles.bulletSvgLg
                    : "";
    return (React.createElement(ListType, { className: data.fontClassName + " " + (data.paddingClassName ? data.paddingClassName + " " : "") + (data.marginClassName ? data.marginClassName + " " : "") + bulletClass + " " + (data.fontClassName === "type-md"
            ? "" + styles.typeMd
            : data.fontClassName === "type-sm"
                ? "" + styles.typeSm
                : data.fontClassName === "type-xs"
                    ? "" + styles.typeXs
                    : data.fontClassName === "type-xxs"
                        ? "" + styles.typeXxs
                        : data.fontClassName === "type-xxxs"
                            ? "" + styles.typeXxxs
                            : "" + styles.typeBase), "data-testid": testId }, data.lists.map(function (item, i) { return (React.createElement("li", { key: i },
        bulletClass.length > 1 && item.icon ? item.icon : null,
        item.text,
        item.textChild ? (React.createElement(ListType, { className: data.fontClassName + " " + (data.childPaddingClassName ? data.childPaddingClassName + " " : "") + (data.childMarginClassName ? data.childMarginClassName + " " : "") + (data.type === "unordered"
                ? "" + styles.bullet
                : data.type === "ordered-alt"
                    ? "" + styles.bullet
                    : "") + " " + (data.fontClassName === "type-md"
                ? "" + styles.typeMd
                : data.fontClassName === "type-sm"
                    ? "" + styles.typeSm
                    : data.fontClassName === "type-xs"
                        ? "" + styles.typeXs
                        : data.fontClassName === "type-xxs"
                            ? "" + styles.typeXxs
                            : data.fontClassName === "type-xxxs"
                                ? "" + styles.typeXxxs
                                : "" + styles.typeBase) }, item.textChild.map(function (childItem, index) { return (React.createElement("li", { key: index }, childItem)); }))) : null)); })));
};
exports.default = Lists;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Lists/Lists.js
// module id = 1782
// module chunks = 8